export default __webpack_public_path__ + "static/media/banner1.5b99e75d.png";